module.exports = __webpack_public_path__ + "static/img/zhyqC.52832ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhyqC.jpg
// module id = a98c
// module chunks = 0